import { api } from '@helpers/api'
import { IItem } from '@/types/IOrder'
import { FormInstance } from 'antd'

export const fillOrderItems = async (
  device: string[],
  form: FormInstance,
  setUrl: any,
  debouncedCalculateAndSetPrices: any
) => {
  return await api.get(`/device/${device}`).then(async (result) => {
    setUrl(`product?type=${result.data.type}&`);

    if (result.data.contracts) {
      const contract = result.data.contracts.at(-1);
      const product = await api.get(`/orderItem?contract=${contract?.uuid}`);
      if (product.data?.data?.[0]?.order_request) {
        return product.data.data[0];
      }
    }

    const url = result.data.contracts?.[0]?.product_uuid
      ? `/product/${result.data.contracts[0].product_uuid}`
      : `/product?type=${result.data.type}`;
    const product = await api.get(url);
    const products = product.data?.items
      ? product.data.items
      : product.data.data[0]?.items;

    const items = products
      .map((item: IItem) => {
        const itemContract = result.data.contracts?.[0]?.[item.item];
        switch (item.type) {
          case "ITEM":
            return {
              item: item,
              current: itemContract || item.min,
            };
          case "SELECT":
            return fillSelectItem(item, itemContract);
          case "LIST":
            return fillMultipleItem(item, itemContract);
          default:
            return null;
        }
      })
      .filter(Boolean);

    return {
      order_request: {
        items: items
      },
      product: product.data.data[0]
    };
  });
};

const fillSelectItem = (item: IItem, itemContract: string) => {
  if (item.children) {
    const listItems = item.children.find((child) => child.item == itemContract)
    if (listItems) {
      return {
        item: item,
        children: { items: [{ item: listItems, uuid: listItems.uuid, current: listItems.min }] }
      };
    }
    return {
      item: item,
      children: { items: [{ item: item.children, uuid: item.uuid, current: item.min }] }
    }
  }
}

const fillMultipleItem = (item: IItem, itemContract: string) => {
  if (item.children) {
    const listItems = item.children.find((child) => child.item == itemContract?.[0]?.type)
    if (listItems) {
      return {
        item: item,
        children: {
          items: [{ current: itemContract?.[0].size, item: listItems }]
        }
      };
    }
    return {
      item: item,
      children: {
        items: [{ current: item.min, item: { uuid: item.uuid } }]
      }
    }
  }
}

